export enum Dig3UserRole {
  Customer = 'Customer',
  ImpersonatedClient = 'ImpersonatedUserClient',
  FirmUser = 'FirmUser',
  MasterFirmUser = 'MasterFirmUser',
  CorporateUser = 'CorporateUser',
  MasterCorporateUser = 'MasterCorporateUser',
}

export type AzureB2CProfileExtension = {
  sub: string
  extension_FigaroPersonCode: string
  extension_QcId: string
  roles: Dig3UserRole[]
}
